import * as React from "react"
import { useContext } from "react"
import CursorContext from "../context/cursorContext"
import SyntaxHighlighter from "react-syntax-highlighter"
import { atomOneDark } from "react-syntax-highlighter/dist/esm/styles/hljs"
import Gist from "super-react-gist"

export const postSerializer: any = {
  types: {
    block: (props: any) => {
      // console.log(props)

      switch (props.node.style) {
        case "normal":
          return (
            <>
              <p className='o-par-lrg'>{props.children}</p>
            </>
          )
        case "h1":
          return (
            <>
              {props.node.children.map((child: any) => (
                <h1 key={child._key}>{child.text}</h1>
              ))}
            </>
          )
        case "h2":
          return (
            <>
              {props.node.children.map((child: any) => (
                <h2 key={child._key}>{child.text}</h2>
              ))}
            </>
          )
        case "h3":
          return (
            <>
              {props.node.children.map((child: any) => (
                <h3 key={child._key}>{child.text}</h3>
              ))}
            </>
          )
        case "h4":
          return (
            <>
              {props.node.children.map((child: any) => (
                <h4 key={child._key}>{child.text}</h4>
              ))}
            </>
          )
        case "h5":
          return (
            <>
              {props.node.children.map((child: any) => (
                <h5 key={child._key}>{child.text}</h5>
              ))}
            </>
          )
        case "h6":
          return (
            <>
              {props.node.children.map((child: any) => (
                <h6 key={child._key}>{child.text}</h6>
              ))}
            </>
          )
        case "blockquote":
          return (
            <div className='c-post__text'>
              {props.node.children.map((child: any) => (
                <blockquote key={child._key}>
                  <p className='o-par-lrg'>
                    {props.node.children.map((innerChild: any) => {
                      if (innerChild.marks.includes("strong")) {
                        return <strong key={innerChild._key}>{innerChild.text}</strong>
                      } else if (innerChild.marks.includes("em")) {
                        return <em key={innerChild._key}>{innerChild.text}</em>
                      } else if (innerChild.marks.includes("strong") && innerChild.marks.includes("em")) {
                        return (
                          <strong key={innerChild._key}>
                            <em>{innerChild.text}</em>
                          </strong>
                        )
                      } else {
                        return <span key={innerChild._key}>{innerChild.text}</span>
                      }
                    })}
                  </p>
                </blockquote>
              ))}
            </div>
          )
        default:
          return null
      }
    },
    code: ({ node = {} }: any) => {
      // console.log(props)

      const { code, language } = node

      if (!code) {
        return null
      } else
        return (
          <SyntaxHighlighter language={language || "text"} style={atomOneDark} showLineNumbers>
            {code}
          </SyntaxHighlighter>
        )
    },
    gist: ({ node }: any) => {
      const { url } = node

      if (!url) return null

      return (
        <div className='o-gist'>
          <Gist url={url}></Gist>
        </div>
      )
    },
  },
  marks: {
    strong: (props: any) => <strong>{props.children}</strong>,
    em: (props: any) => <em>{props.children}</em>,
    link: ({ mark, children }: any) => {
      const { href } = mark
      /* eslint-disable-next-line */
      const { setCursorState } = useContext(CursorContext)

      return (
        <a
          href={href}
          className='o-inline-link is-bodylink'
          target='_blank'
          rel='noopener noreferrer'
          onMouseEnter={() => setCursorState?.("is-link")}
          onMouseLeave={() => setCursorState?.("")}
        >
          {children}
        </a>
      )
    },
  },
  list: (props: any) => {
    //     console.log(props)
    return <>{props.type === "bullet" ? <ul>{props.children}</ul> : <ol>{props.children}</ol>}</>
  },
  listItem: (props: any) => {
    //     console.log(props)
    return (
      <li>
        <p className='o-par-lrg'>{props.children}</p>
      </li>
    )
  },
}
